var map = {
	"./de/triangleIcon.png": "at5q",
	"./en/triangleIcon.png": "uthe",
	"./es/triangleIcon.png": "eWPs",
	"./fr/triangleIcon.png": "ySdv",
	"./ja/triangleIcon.png": "FiKl",
	"./ko/triangleIcon.png": "8LJj",
	"./pt/triangleIcon.png": "fQ9w",
	"./ru/triangleIcon.png": "obZM",
	"./tc/triangleIcon.png": "Ud+F",
	"./th/triangleIcon.png": "uuvx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "FY4g";